// src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import  ErrorMessage from '../components/common/ErrorMessage';
import {
  LoginPage,
  LoginSection,
  BackgroundSection,
  LoginTitle,
  LoginForm,
  FormGroup,
  Label,
  Input,
  Button
} from '../styles/LoginStyles';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    const success = await login({ email, password });
    if (success) {
      navigate('/home');
    } else {
      setError('Login failed. Please check your credentials.');
    }
  };

  return (
    <LoginPage>
      <LoginSection>
        <LoginForm onSubmit={handleSubmit}>
          <LoginTitle>Login</LoginTitle>
          
          {error && <ErrorMessage message={error} />}
          
          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FormGroup>

          <Button type="submit">
            Sign in
          </Button>
        </LoginForm>
      </LoginSection>
      
      <BackgroundSection />
    </LoginPage>
  );
};

export default Login;